module.exports = __webpack_public_path__ + "static/media/staff-scelera.e309fa8e.png";